module.exports = __webpack_public_path__ + "img/trends_1.035dc91e.jpg";